// 封装所有与用户相关的网络请求
import request from "@/utils/request";


// 客户迁移列表
export function queryFollowUserRequestLisApi(data) {
  return request({
    url: "api/followuser/list",
    method: "POST",
    data: data,
  });
}

export function queryTagListApi(data) {
  return request({
    url: "/api/followuser/taglist",
    method: "post",
    params: data,
  });
}

// 客户迁移列表接口导出
export function followUserExportApi(data){
  return request({
    url:"api/followuser/export",
    method: "post",
    data: data
  })
}

export function importWebComExlsx(data) {
  return request({
    url: "api/followuser/importExcel",
    // url: "/api/custLvlRequest/import",
    method: "POST",
    timeout: 1000 * 600,
    data: data,
  });
}

//区域或者门店域信息
export const regionalQuery = (data) => {
  return request({
    url: "/api/followuser/selectQiYeDepartment",
    method: "POST",
    params: data
  })
}


